import Cookies from "js-cookie";
import moment from "moment";
export const surveyCookieName = (surveyId: string, iterationNo: number) =>
  `team-o-meter_survey_${surveyId}_${iterationNo}`;

export const setSurveyAnswered = (surveyId: string, iterationNo: number) =>
  Cookies.set(surveyCookieName(surveyId, iterationNo), moment().format());

export const alreadyAnswered = (surveyId: string, iterationNo: number) => {
  const cookie = Cookies.get(surveyCookieName(surveyId, iterationNo));
  return cookie !== undefined;
};
